import services from './services.js';
//组件
import AddAreaDialog from './components/AddAreaDialog/index.vue';
import viewDialog from '../components/viewDialog/index.vue'; //查看弹窗
import selectStaffDialog from 'selectStaffDialog';
import areaSelect from 'area-select';
import employee from 'Employee';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    $http,
    MAP_LIST
} from '$http';

export default {
    mixins: [services],
    components: {
        selectStaffDialog,
        AddAreaDialog,
        viewDialog,
        'area-select': areaSelect,
        'employee': employee
    },
    data() {
        return {
            /* 主表数据 */
            loading: false,
            lists: [], //表格内容
            employeeVisiable: false,
            selectEmployeeName: '',
            employee: {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            },
            areaInfo: this.getAreaInfo(),
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            query: this.getSrarchFormData(),
            intentProjectList: MAP_LIST.INTENT_PROJECT,
            queryType: [{
                    TypeName: "全部",
                    TypeValue: "-1"
                },
                {
                    TypeName: "待主管审核",
                    TypeValue: "0"
                },
                {
                    TypeName: "主管审核不通过",
                    TypeValue: "1"
                }, {
                    TypeName: "已新增",
                    TypeValue: "2"
                }, {
                    TypeName: "待财务审核",
                    TypeValue: "3"
                }, {
                    TypeName: "财务审核不通过",
                    TypeValue: "4"
                }
            ],
            LevelTypes: [{
                    key: 1,
                    value: "意向商"
                },
                {
                    key: 2,
                    value: "C级商"
                }, {
                    key: 4,
                    value: "B级商"
                }, {
                    key: 8,
                    value: "A级商"
                }
            ]
        }
    },
    methods: {
        getSrarchFormData() {
            return cloneDeep({
                Customer: '',
                CName: '',
                ContractNumber: '',
                ProjectType: '',
                PolicyType: '',
                ProvId: '',
                CityId: '',
                AreaId: '',
                AuditStatus: '',
                StartAddtime: '',
                EndAddtime: '',
                StartDate: '',
                EndDate: '',
                Employee_id: '',
                D_id: '',
                RebateLevel: ''
            })
        },
        getAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null
            });
        },
        showEmployeeDialog() {
            this.$refs.refSelectStaffDialog.show();
        },
        selectedStaff(obj) {
            // this.$refs.baseInfo.setStaffInfo(item);
            this.selectEmployeeName = obj.name;
            // this.transferForm.EmployeeId = obj.ID;
        },


        //分页选定行
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        //分页监听dd页面
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },



        // 查看
        showDetails(row) {

            this.$refs.viewDialog.show({
                Id: row.customerId,
                AgentAreaId: row.AgentAreaId,
                title: '查看',
                msg: row
            })
        },
        // 修改
        goToModify(row) {
            this.$refs.AddAreaDialog.show({
                Id: row.customerId,
                AgentId: row.Id,
                AgentAreaId: row.AgentAreaId,
                title: '修改',
                msg: row
            })

        },
        // 新增区域
        addArea() {
            this.$refs.AddAreaDialog.show({
                title: '新增区域',
            })
        },
        // 查询
        onQuerySubmit() {
            let areaData = this.$refs.areaForm.getAreaData()
            this.query.ProvId = areaData.Provinces_Id;
            this.query.CityId = areaData.City_Id;
            this.query.AreaId = areaData.Area_Id;
            this.pageIndex = 1;
            this.getList();
        },
        onQueryClean() {
            this.query = this.getSrarchFormData()
            this.areaInfo = this.getAreaInfo()
            this.$refs.areaForm.resetFields()
            this.employee = {
                d_name: '', //选中的部门名称
                employeeName: '' //选中的员工名称
            };
            this.pageIndex = 1;
            this.getList();
        },
        //导出功能
        download() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                this.getList();
                var params = {
                    Sid: this.$store.state.sysSid,
                    Session: this.$store.state.sysSession,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                };
                let areaData = this.$refs.areaForm.getAreaData()
                this.query.ProvId = areaData.Provinces_Id;
                this.query.CityId = areaData.City_Id;
                this.query.AreaId = areaData.Area_Id;
                for (let item in this.query) {
                    let value = this.query[item];
                    if (value != '') {
                        params[item] = value;
                    }
                }
                util.exportToFileV2("api/AgentAreas/AgentAreaExport", params, this);
            });

        },
        showEmployee() {
            this.employeeVisiable = true;
        },
        selectEmployee(data) {
            this.query.D_id = data.d_id;
            this.query.Employee_id = data.employeeId;
            this.employee.d_name = data.d_name;
            this.employee.employeeName = data.employeeName;
        }

    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
        PoliceList() {
            if (this.query.ProjectType == 2) {
                return [{
                    key: 64,
                    value: "2018Q2招商政策"
                }]
            } else if (this.query.ProjectType == 4) {
                return [{
                    key: 8,
                    value: "N29"
                }]
            } else {
                return []
            }
        },
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAreaList/vm.js